import { useAuthStore } from "@/store/auth/auth.store";
import { PATH_HOME } from "@routes/paths";
import AuthQuote from "@components/auth/auth.quote";
import AuthLogo from "@components/auth/auth.logo";
import AuthTitle from "@components/auth/auth.title";
import LoginForm from "./login.form";
import { Navigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { setAuthProvider, setAuthToken, setRefreshToken } from "@/utils/axios-instance";

const LoginContainer = () => {
  const { isLoggedIn } = useAuthStore();
  const [searchParams] = useSearchParams();

  // check if access_token param is defined in the URL
  const access_token = searchParams.get("access_token");
  const refresh_token = searchParams.get("refresh_token");
  const auth_provider = searchParams.get("auth_provider");
  // Get the redirect URL from query parameters
  const redirectUrl = searchParams.get("redirect");

  useEffect(() => {
    if (access_token && refresh_token && auth_provider) {
      setAuthToken(access_token);
      setRefreshToken(refresh_token);
      setAuthProvider(auth_provider);
      useAuthStore.getState().initializeApp();
      useAuthStore.getState().getProfile();
    }
  }, [access_token, refresh_token, auth_provider]);

  // After successful login, redirect to the original URL or home
  if (isLoggedIn) {
    const targetUrl = redirectUrl ? decodeURIComponent(redirectUrl) : PATH_HOME;
    return <Navigate to={targetUrl} replace />;
  }
  return (
    <div className="grid lg:grid-cols-2 min-h-screen">
      <div className="w-full h-full bg-gray-100 p-10 lg:p-20">
        <div className="mx-auto max-w-sm">
          <AuthLogo />
          <AuthTitle />
          <LoginForm />
        </div>
      </div>
      <AuthQuote />
    </div>
  );
};

export default LoginContainer;
